import React, { useState, useEffect } from 'react';
import './KennisbankBeheer.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://womsys.nl/api';

function KennisbankBeheer() {
  const [artikelen, setArtikelen] = useState([]);
  const [merken, setMerken] = useState([]);
  const [zoekterm, setZoekterm] = useState('');
  const [selectedMerk, setSelectedMerk] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const [importing, setImporting] = useState(false);
  const [nieuwCode, setNieuwCode] = useState('');
  const [nieuwMerk, setNieuwMerk] = useState('');
  const [nieuwTitel, setNieuwTitel] = useState('');
  const [nieuwTip, setNieuwTip] = useState('');
  const token = localStorage.getItem('token');
  const [editArtikel, setEditArtikel] = useState(null);
  const [afdelingen, setAfdelingen] = useState([]);
  const [nieuwAfdeling, setNieuwAfdeling] = useState('');
  useEffect(() => { fetch(`${API_URL}/afdelingen`, { headers: { 'Authorization': `Bearer ${token}` } }).then(r => r.json()).then(d => setAfdelingen(Array.isArray(d) ? d : (d.afdelingen || d.data || []))).catch(() => {}); }, []);
  const fetchArtikelen = async () => {
    try {
     const res = await fetch(`${API_URL}/kennisbank`, {     

      headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setArtikelen(data.artikelen);
        const uniqueMerken = [...new Set(data.artikelen.map(a => a.merk).filter(Boolean))];
        setMerken(uniqueMerken);
      }
    } catch (err) {
      console.error('Fout:', err);
    }
  };

  useEffect(() => { fetchArtikelen(); }, []);

  const handlePDFUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    setUploadResult(null);
    const formData = new FormData();
    formData.append('pdf', file);
    try {
      const res = await fetch(`${API_URL}/kennisbank/upload-pdf`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const data = await res.json();
      setUploadResult(data);
    } catch (err) {
      setUploadResult({ success: false, message: err.message });
    }
    setLoading(false);
  };

  const handleImport = async () => {
    if (!uploadResult?.codes || !nieuwMerk) {
      alert('Selecteer eerst een merk');
      return;
    }
    setImporting(true);
    try {
      const res = await fetch(`${API_URL}/kennisbank/importeer`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ merk: nieuwMerk, codes: uploadResult.codes, bedrijf_id: 1 })
      });
      const data = await res.json();
      if (data.success) {
        alert('✅ ' + data.toegevoegd + ' codes geïmporteerd!');
        setUploadResult(null);
        fetchArtikelen();
      } else {
        alert('Fout: ' + data.message);
      }
    } catch (err) {
      alert('Fout: ' + err.message);
    }
    setImporting(false);
  };

  const handleNieuwOpslaan = async () => {
    if (!nieuwCode || !nieuwMerk || !nieuwTitel) {
      alert('Vul code, merk en titel in');
      return;
    }
    try {
      const res = await fetch(`${API_URL}/kennisbank`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: nieuwCode, merk: nieuwMerk, titel: nieuwTitel, tip: nieuwTip, afdeling_id: nieuwAfdeling || null, bedrijf_id: 1 })
      });
      const data = await res.json();
      if (data.success) {
        alert('✅ Code toegevoegd!');
        setNieuwCode(''); setNieuwTitel(''); setNieuwTip('');
        fetchArtikelen();
      }
    } catch (err) {
      alert('Fout: ' + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Weet je zeker?')) return;
    try {
      await fetch(`${API_URL}/kennisbank/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      fetchArtikelen();
    } catch (err) {
      alert('Fout: ' + err.message);
    }
  };

const handleEdit = async () => {
    if (!editArtikel) return;
    try {
      const res = await fetch(`${API_URL}/kennisbank/${editArtikel.id}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(editArtikel)
      });
      const data = await res.json();
      if (data.success) {
        alert('✅ Opgeslagen!');
        setEditArtikel(null);
        fetchArtikelen();
      }
    } catch (err) {
      alert('Fout: ' + err.message);
    }
  };

  const filtered = artikelen.filter(a => {
    const matchZoek = !zoekterm || a.code?.toLowerCase().includes(zoekterm.toLowerCase()) || a.titel?.toLowerCase().includes(zoekterm.toLowerCase());
    const matchMerk = !selectedMerk || a.merk === selectedMerk;
    return matchZoek && matchMerk;
  });

  return (
    <div className="kennisbank-beheer">
      <h1>📚 Kennisbank Beheer</h1>
      <div className="sectie">
        <h2>📄 PDF Importeren</h2>
        <p className="hint">Upload een PDF met foutcodes.</p>
        <input type="file" accept=".pdf" onChange={handlePDFUpload} disabled={loading} />
        {loading && <p>⏳ PDF wordt gescand...</p>}
        {uploadResult && uploadResult.success && (
          <div className="upload-result">
            <h3>✅ {uploadResult.codes?.length || 0} codes gevonden</h3>
            <input type="text" placeholder="Merk (bijv. Hanning & Kahl)" value={nieuwMerk} onChange={e => setNieuwMerk(e.target.value)} />
            <button onClick={handleImport} disabled={importing}>{importing ? '⏳...' : '📥 Importeer'}</button>
            <div className="preview">{uploadResult.codes?.slice(0,5).map((c,i) => <div key={i}><strong>{c.code}</strong> - {c.titel}</div>)}</div>
          </div>
        )}
        {uploadResult && !uploadResult.success && <p className="error">❌ {uploadResult.message}</p>}
      </div>
      <div className="sectie">
        <h2>➕ Handmatig toevoegen</h2>
        <div className="form-grid">
          <input placeholder="Code" value={nieuwCode} onChange={e => setNieuwCode(e.target.value)} />
          <input placeholder="Merk" value={nieuwMerk} onChange={e => setNieuwMerk(e.target.value)} />
          <input placeholder="Titel" value={nieuwTitel} onChange={e => setNieuwTitel(e.target.value)} />
          <textarea placeholder="Tip/Oplossing" value={nieuwTip} onChange={e => setNieuwTip(e.target.value)} />
          <select value={nieuwAfdeling} onChange={e => setNieuwAfdeling(e.target.value)}>
            <option value="">Hele bedrijf (alle afdelingen)</option>
            {afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)}
          </select>
          <button onClick={handleNieuwOpslaan}>💾 Opslaan</button>
        </div>
      </div>
      <div className="sectie">
        <h2>📋 Overzicht ({filtered.length})</h2>
        <div className="filters">
          <input placeholder="🔍 Zoeken..." value={zoekterm} onChange={e => setZoekterm(e.target.value)} />
          <select value={selectedMerk} onChange={e => setSelectedMerk(e.target.value)}>
            <option value="">Alle merken</option>
            {merken.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div className="artikelen-lijst">
          {filtered.map(a => (
            <div key={a.id} className="artikel-item">
              <div className="artikel-header">
                <span className="code">{a.code}</span>
                <span className="merk">{a.merk}</span>
                 <button onClick={() => setEditArtikel(a)}>✏️</button>
                <button onClick={() => handleDelete(a.id)}>🗑️</button>
              </div>
              <h4>{a.titel}</h4>
              <p>{a.tip}</p>
            </div>
          ))}
        </div>
      </div>
{editArtikel && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: 24, borderRadius: 12, width: 500, maxWidth: '90%' }}>
            <h3>✏️ Bewerken: {editArtikel.code}</h3>
            <input placeholder="Code" value={editArtikel.code} onChange={e => setEditArtikel({...editArtikel, code: e.target.value})} style={{ width: '100%', padding: 10, marginBottom: 10, borderRadius: 6, border: '1px solid #ccc' }} />
            <input placeholder="Merk" value={editArtikel.merk || ''} onChange={e => setEditArtikel({...editArtikel, merk: e.target.value})} style={{ width: '100%', padding: 10, marginBottom: 10, borderRadius: 6, border: '1px solid #ccc' }} />
            <input placeholder="Titel" value={editArtikel.titel || ''} onChange={e => setEditArtikel({...editArtikel, titel: e.target.value})} style={{ width: '100%', padding: 10, marginBottom: 10, borderRadius: 6, border: '1px solid #ccc' }} />
            <textarea placeholder="Tip" value={editArtikel.tip || ''} onChange={e => setEditArtikel({...editArtikel, tip: e.target.value})} style={{ width: '100%', padding: 10, marginBottom: 10, borderRadius: 6, border: '1px solid #ccc', minHeight: 100 }} />
            <select value={editArtikel.afdeling_id || ''} onChange={e => setEditArtikel({...editArtikel, afdeling_id: e.target.value || null})} style={{ width: '100%', padding: 10, marginBottom: 10, borderRadius: 6, border: '1px solid #ccc' }}>
              <option value="">Hele bedrijf (alle afdelingen)</option>
              {afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)}
            </select>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setEditArtikel(null)} style={{ flex: 1, padding: 12, borderRadius: 6, border: '1px solid #ccc', background: 'white' }}>Annuleren</button>
              <button onClick={handleEdit} style={{ flex: 1, padding: 12, borderRadius: 6, border: 'none', background: '#1e40af', color: 'white' }}>💾 Opslaan</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default KennisbankBeheer;
